<template>
  <div>
    <v-container>
      <!-- title -->
      <div class="d-flex align-center mx-6 mt-4 mb-6">
        <v-btn icon class="mr-4" @click="$router.back()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h2 class="font-weight-regular">
          Now Viewing <b>{{ reportName }}</b>
        </h2>
      </div>
      <!-- title -->

      <BoldReportViewer />
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import strings, { SyntaxCase } from "../../../utils/strings";
export default {
  computed: {
    reportName() {
      return this.$store.getters.getCurrentReport;
      // return this.$route.params.reportName;
    },

    reportNameHumanCase() {
      const reportNameFromUrl = this.reportName;
      const reportName = reportNameFromUrl.substring(0, 4);
      return strings.changeSyntax(
        reportNameFromUrl,
        SyntaxCase.camelCase,
        SyntaxCase.humanCase
      );
    },
  },
  beforeMount() {
    this.$store.commit("setSideNavigatorOpened", true);
  },
  beforeDestroy() {
    this.$store.commit("setSideNavigatorOpened", false);
  },
};
</script>
